import { autoinject } from 'aurelia-framework';
import { NavigationInstruction } from 'aurelia-router';

@autoinject
export class AuthorizationRedirectManager {
	private navigationInstruction: NavigationInstruction;

	// store the navigationInstruction to get preAuthUri and return login uri for redirect
	handleNotAuthorized(navigationInstruction: NavigationInstruction): string {
		this.navigationInstruction = navigationInstruction;

		return `portal/${this.navigationInstruction.params.id}/login`;
	}

	// use the navigationInstruction to re-create the pre auth uri
	getPreAuthUri(): string {
		if (!this.navigationInstruction) {
			return null;
		}

		// replaces existing view model invoking router lifecycle hooks
		let uri = this.navigationInstruction.router.generate(this.navigationInstruction.config.name,
			this.navigationInstruction.params);

		this.navigationInstruction = null; // clear after used once

		return uri;
	}

	get NavigationInstruction() {
		return this.navigationInstruction;
	}
}
